// extracted by mini-css-extract-plugin
export default {"option":"UserOption_option__-SVGK"};